import Service from "../Service";

const resource = "typestatefinal/";

export default {
    save(fas, requestID){
        return Service.post(resource + "save", fas,{
            params: {requestID: requestID},
        });
    },
    pagination(dtr, requestID){
        return Service.post(resource + "pagination", dtr,{
            params:{requestID: requestID},
        });
    },
    list(fas, requestID) {
        return Service.post(resource + "list", fas, {
          params: { requestID: requestID },
        });
    },
    

}